<template>
  <div class="content">
    <h1>{{ pageTitle }}</h1>

    <Spin size="large" fix v-if="spinShow"></Spin>

    <div class="content-body two-columns">
      <div class="left">
        <div class="block">
          <PartForm :manufacturerPart="manufacturerPart" v-bind:formData.sync="partFormData"
            @on-saved="onPartBaseInfoSaved"></PartForm>
          <span style="color: #9ea7b4;" v-if="manufacturerPart">{{ $t('date') }}: {{ manufacturerPart.updated_at || manufacturerPart.created_at }}</span>
        </div>

        <div class="block margin-top-20">
          <h2 style="margin-top: 0">{{ $t('part.info.part_number') }}</h2>
          <PartNumberForm v-if="showPartNumberForm" :part="manufacturerPart"></PartNumberForm>
          <span class="warning" v-else>{{ $t('part.info.ensure_part_is_reviewed_and_category_set') }}</span>
        </div>

        <div class="block margin-top-20">
          <h2>{{ $t('part.spec_property_values') }}</h2>
          <PartSpecPropertiesForm v-if="hasManufacturerPartLoaded"
            ref="specsForm"
            :manufacturerPart="manufacturerPart"
            :categoryId="manufacturerPart.part_category_id"
            :spec-attributes="specValues"
            :loading="loadingSpecValues"
            @specs-saved="onSpecsSaved">
          </PartSpecPropertiesForm>
        </div>
      </div><!-- leftside end -->

      <!-- rightside -->
      <div class="right">
        <div class="block">
          <h2>{{ $t('mechanical.image') }}</h2>
          <Uploader v-if="partId" @on-success="handleFileUploaded" :defaultFileList="thumbData" :model-id="partId" :model-type="modelType" :max-num="1" accept=".jpg, .jpeg, .png, .gif, .svg, .bmp" drag-drop></Uploader>
        </div>

        <div class="block margin-top-20">
          <h2>{{ $t('part.alternatives') }}</h2>
          <PartSubstituteList :part-id="Number.parseInt(partId)" :current-part="manufacturerPart"></PartSubstituteList>
        </div>

        <div v-if="customerInformation.length > 0" class="block margin-top-20">
          <h2>{{ $t('part.customer_information') }}</h2>
          <div v-for="item in customerInformation" :key="item.id">
            {{ item.account.name }} <span v-if="item.account.account_number">({{ item.account.account_number }})</span> ---- {{ item.part_number }}
          </div>
        </div>

        <div class="block margin-top-20">
          <h2>{{ $t('part.similar_parts') }}</h2>
          <SimilarParts v-if="componentType && partId" :component-type="componentType" :id="partId"></SimilarParts>
        </div>
      </div>
      <!-- rightside end -->
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PartNumberForm from './components/forms/part-number-form'
import Uploader from '@/components/images/uploader'
import PartForm from './components/forms/part-form'
import PartSpecPropertiesForm from "./components/forms/part-spec-properties-form"
import SimilarParts from './components/widgets/similar-parts'
import PartSubstituteList from './substitution/part-substitute-list'
import { uploadThumbnail } from '@/api/file'

export default {
  name: 'PartEdit',
  components: {
    PartForm,
    Uploader,
    PartNumberForm,
    PartSpecPropertiesForm,
    SimilarParts,
    PartSubstituteList
  },
  data () {
    return {
      spinShow: false,
      modelType: 'electronic_part',
      partFormData: null,
      manufacturerPart: null,
      specValues: [],
      thumbData: [],
      loadingSpecValues: true,
      customerInformation: [],
      partId: this.$route.params.partId
    }
  },
  mounted () {
    this.loadPart()
    this.loadSpecValues(this.$route.params.partId)
  },
  computed: {
    specValue: function () {
      return this.partFormData?.specification
    },
    hasManufacturerPartLoaded: function () {
      return this.manufacturerPart && this.manufacturerPart.id
    },
    componentType: function () {
      return this.manufacturerPart?.component_type
    },
    showPartNumberForm: function () {
      return this.manufacturerPart && this.manufacturerPart.reviewed === 1
    },
    pageTitle () {
      document.title = this.$t('menu.part.edit.title')
      return document.title
    }
  },
  methods: {
    ...mapActions([
      'getElectronicPart',
      'getElectronicPartSpec'
    ]),
    loadSpecValues (partId) {
      this.getElectronicPartSpec(partId).then(resp => {
        this.specValues = resp
      }).finally(() => {
        this.loadingSpecValues = false
      })
    },
    loadPart() {
      if (!this.partId) return

      this.spinShow = true
      this.getElectronicPart(this.partId).then((resp) => {
        this.manufacturerPart = resp
        this.customerInformation = resp.customer_provided_parts
        this.thumbData = resp.thumb
      }).finally(() => {
        this.spinShow = false
      })
    },
    onPartBaseInfoSaved(manufacturerPart) {
      this.loadPart()
    },
    onSpecsSaved(manufacturerPart) {
      this.loadPart()
      // this.updateForm(manufacturerPart)
    },
    handleChangedSubstitution() {
      this.$refs.substitutions.handleLoadSubstitutions(this.manufacturerPart)
    },
    handleFileUploaded (fileManaged) {
      uploadThumbnail(this.modelType, this.partId, fileManaged.id).then(resp => {
        this.$Message.success('Upload successfully!')
      })
    }
  },
  watch: {
    '$route.params.partId': function () {
      this.loadPart()
    }
  }
}
</script>
